var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "social-icon-container" }, [
    _c(
      "div",
      { staticClass: "social-icon", class: `name-${_vm.name}` },
      [
        _vm.name === "facebook"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fab",
                    "data-icon": "facebook-f",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 264 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "google-plus"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fab",
                    "data-icon": "google-plus",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 496 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm-70.7 372c-68.8 0-124-55.5-124-124s55.2-124 124-124c31.3 0 60.1 11 83 32.3l-33.6 32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9 0-77.2 35.5-77.2 78.1s34.2 78.1 77.2 78.1c32.6 0 64.9-19.1 70.1-53.3h-70.1v-42.6h116.9c1.3 6.8 1.9 13.6 1.9 20.7 0 70.8-47.5 121.2-118.8 121.2zm230.2-106.2v35.5H372v-35.5h-35.5v-35.5H372v-35.5h35.5v35.5h35.2v35.5h-35.2z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "youtube"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fab",
                    "data-icon": "youtube",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 576 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "twitter"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fab",
                    "data-icon": "twitter",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "vimeo"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fab",
                    "data-icon": "vimeo",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "linkedin"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fab",
                    "data-icon": "linkedin-in",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M100.3 480H7.4V180.9h92.9V480zM53.8 140.1C24.1 140.1 0 115.5 0 85.8 0 56.1 24.1 32 53.8 32c29.7 0 53.8 24.1 53.8 53.8 0 29.7-24.1 54.3-53.8 54.3zM448 480h-92.7V334.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V480h-92.8V180.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V480z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "pinterest"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fab",
                    "data-icon": "pinterest",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 496 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "skype"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fab",
                    "data-icon": "skype",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "instagram"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-prefix": "fab",
                    "data-icon": "skype",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    staticClass: "icon",
                    attrs: {
                      fill: "currentColor",
                      d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.name === "trip-advisor"
          ? [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    "aria-hidden": "true",
                    "data-icon": "trip advisor",
                    viewBox: "0 0 87.5 57.4",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M24.1 6.1C11.4 6.1 1 16.4 1 29.2s10.4 23.2 23.1 23.2c12.8 0 23.2-10.4 23.2-23.2 0-12.8-10.4-23.1-23.2-23.1zm0 34c-6 0-10.9-4.9-10.9-10.9s4.9-10.9 10.9-10.9S35 23.2 35 29.2s-4.8 10.9-10.9 10.9z",
                    },
                  }),
                  _c("circle", { attrs: { cx: "24.1", cy: "29.2", r: "4.4" } }),
                  _c("path", {
                    attrs: {
                      d: "M62 6.1c-12.8 0-23.2 10.4-23.2 23.2C38.9 42 49.2 52.4 62 52.4c12.8 0 23.2-10.4 23.2-23.2C85.2 16.4 74.8 6.1 62 6.1zm0 34c-6 0-10.9-4.9-10.9-10.9S56 18.3 62 18.3s10.9 4.9 10.9 10.9S68.1 40.1 62 40.1z",
                    },
                  }),
                  _c("circle", { attrs: { cx: "62", cy: "29.2", r: "4.4" } }),
                  _c("path", {
                    attrs: {
                      d: "M7.1 17.3L0 0l17.3 7.1L7.1 17.3zm63.1-9.2L87.5 1l-7.1 17.3L70.2 8.1zm-20.3 32l-7.2 17.3-7.2-17.3h14.4z",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }